exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mx-datepicker-range{width:250px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Datepicker.vue"],"names":[],"mappings":"AACA,qBACC,WAAa,CACb","file":"Datepicker.vue","sourcesContent":["\n.mx-datepicker-range {\n\twidth: 250px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8fbc336e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Datepicker.vue
// module id = 1614
// module chunks = 3 4 5 6 8 20